<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-[51] flex justify-center bg-black/50"
  >
    <div
      class="absolute top-16 flex flex-col bg-white rounded-lg shadow-lg p-6 w-full max-w-md"
    >
      <div class="flex flex-row justify-end">
        <button @click="isOpen = false" type="button">
          <XIcon class="w-5 h-5 text-gray-500" />
        </button>
      </div>
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-4">
          <template v-if="type === 'reject'">
            <div class="flex justify-center">
              <img src="@/assets/images/quotation/reject.png" alt="" />
            </div>
            <p class="text-title">
              ¡Atención! ¿Está seguro que quiere rechazar la cotización?
            </p>
            <p class="text-center">
              Al rechazar, esta solicitud de cotización se cerrará de forma
              permanente y no podrá ser reabierta. Si desea cotizar nuevamente,
              deberá iniciar un nuevo proceso.
            </p>
          </template>
          <template v-if="type === 'edit'">
            <div class="flex justify-center">
              <img src="@/assets/images/quotation/edit.png" alt="" />
            </div>
            <p class="text-title">¿Desea editar la propuesta actual?</p>
            <p class="text-center">
              Al proceder con la edición, se modificará la propuesta inicial
              para actualizarla con sus cambios.
            </p>
          </template>
          <template v-if="type === 'accept'">
            <div class="flex justify-center">
              <img src="@/assets/images/quotation/accept.png" alt="" />
            </div>
            <p class="text-title">¿Desea aceptar la propuesta modificada?</p>
            <p class="text-center">
              Al confirmar, acepta las modificaciones realizadas por el operador
              y autoriza la generación de la cotización final en base a estos
              cambios.
            </p>
          </template>
        </div>
        <div class="flex flex-col w-full items-center gap-2">
          <button
            @click="emit('click:action')"
            class="btn btn-quotation rounded-lg px-5 md:mt-0 mt-5 w-full sm:w-1/2 text-base"
          >
            Aceptar
          </button>
          <button
            type="button"
            @click="isOpen = false"
            class="btn btn-quotation-outline rounded-lg px-5 w-full sm:w-1/2 text-base"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, defineProps, defineEmits } from 'vue'
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['update:modelValue', 'click:action'])

const isOpen = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
</script>
<style scoped>
.text-title {
  font-family: Crimson Pro;
  font-weight: 700;
  font-style: Bold;
  font-size: 30px;
  line-height: 30px;
  letter-spacing: 0px;
  text-align: center;
  color: #ce0100;
}
</style>
